export default __webpack_public_path__ + "static/media/img3.67e0d19f.png";